import { newDirectoryGroupAccesses } from "@p0security/shared/integrations/directories/accesses";
import { groupAndRoleFilters } from "@p0security/shared/integrations/directories/filters";
import { registerIntegration } from "@p0security/shared/integrations/registry";
import { Registration } from "@p0security/shared/integrations/types";

import { EntraIdIconUrl } from "../entra-id/registry.ts";

export const AzureAdRegistration = Registration({
  accesses: newDirectoryGroupAccesses("ga"),
  category: "directory",
  components: "oauth",
  docs: { install: "microsoft-entra-id-legacy" },
  filters: groupAndRoleFilters,
  label: "Entra ID (legacy)",
  logoUrl: EntraIdIconUrl,
  maturity: "ga",
  requestType: "requestable",
  useMapping: [],
});

registerIntegration("azure-ad", AzureAdRegistration);
